import { API } from "../../../utils";

export const PlayOrPauseAllBirthdayCoupon = async (id) => {
  const res = await API.post(`coupons/${id}/play-pause`);
  return res.data;
};

// New V2 update function with id parameter
export const updateBirthdayCouponsV2 = async (id, payload) => {
  const res = await API.post(`coupons/birthday/${id}`, payload);
  return res.data;
};

export const getAllConditionList = async () => {
  const res = await API.get("rule-sets ");
  return res.data;
};

// New function for getting birthday coupon customers
export const getBirthdayCouponCustomers = async (id, query, pagination) => {
  const { pageIndex, pageSize } = pagination;
  let url = `coupons/birthday/customers?page=${pageIndex}&per_page=${pageSize}`;
  const res = await API.get(url, query);
  return res.data;
};

export const getBirthdayCouponsDetails = async () => {
  const res = await API.get(`coupons/birthday`);
  return res.data;
};
